import '../scss/main.scss';

import { App } from './app/app';

const app = new App();
app.initialize();
